import { css } from 'styled-components';
export var headingStyles = /*#__PURE__*/css(["font-family:", ";font-weight:", ";line-height:", ";color:", ";padding:0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.lineHeight.heading;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.heading.primary;
});
export var textStyles = /*#__PURE__*/css(["font-size:", ";font-family:", ";font-weight:", ";line-height:", ";color:", ";padding:0;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.fontSize.ft16;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fonts.fontWeight.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fonts.lineHeight.text;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.text.primary;
});